import * as React from 'react'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'
import * as api from '@owl-nest/api-client/latest'
import { t } from '@owl-nest/localize'
import * as env from '@owl-nest/config'

import { footerBreakpoint } from './constants'

type ToesProps = {
  className?: string
  lang: api.Lang
  $lang: api.Lang
}

function ToesComponent({ className, lang }: ToesProps) {
  return (
    <div className={className}>
      <LogoLink href={`${env.ULULE_ORIGINS[lang]}/`} aria-label={t('Ulule home')}>
        <plume.logos.ulule.HorizontalLogo />
      </LogoLink>

      <SocialLinks $lang={lang}>
        <li>
          <plume.Link
            href={`https://www.facebook.com/${env.FACEBOOK_ACCOUNTS[lang] ?? env.FACEBOOK_ACCOUNTS.en}`}
            target="_blank"
            title="Facebook"
          >
            <plume.glyphs.thirdParty.Facebook size={14} />
          </plume.Link>
        </li>
        <li>
          <plume.Link href={`https://tiktok.com/@ulule_off`} target="_blank" title="TikTok">
            <plume.glyphs.thirdParty.Tiktok size={14} />
          </plume.Link>
        </li>
        <li>
          <plume.Link href="https://www.instagram.com/ulule/" target="_blank" title="Instagram">
            <plume.glyphs.thirdParty.Instagram size={14} />
          </plume.Link>
        </li>
        <li>
          <plume.Link href="https://www.linkedin.com/company/ulule" target="_blank" title="LinkedIn">
            <plume.glyphs.thirdParty.Linkedin size={15} />
          </plume.Link>
        </li>
        <li>
          <plume.Link href="https://www.youtube.com/user/UluleChouette" target="_blank" title="YouTube">
            <plume.glyphs.thirdParty.Youtube size={15} />
          </plume.Link>
        </li>
      </SocialLinks>

      <LegalLinks $lang={lang}>
        <LinkItem as="li">
          <plume.Link href={env.TERMS_OF_USE_URL}>{t('Terms of use')}</plume.Link>
        </LinkItem>
        <LinkItem as="li">
          <plume.Link href={env.COOKIE_POLICY_URL}>{t('Cookies')}</plume.Link>
        </LinkItem>
        <LinkItem as="li">
          <plume.Link href={env.PRIVACY_URL}>{t('Privacy')}</plume.Link>
        </LinkItem>
      </LegalLinks>
    </div>
  )
}
export const Toes = styled(ToesComponent)<{ $lang: string }>`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0px auto;
  padding: 33px 0;
  position: relative;

  @media screen and ${(props) => footerBreakpoint(props.$lang)} {
    align-items: center;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    margin: 0px auto;
    max-width: 900px;
    min-height: 68px;
    padding: 0;
    width: 100%;
  }
`

const LogoLink = styled.a`
  color: ${plume.COLORS.PRIMARY_BLACK};

  &:hover {
    color: ${plume.COLORS.PRIMARY_BLACK};
  }
`

const LinkItem = styled(plume.styles.copy.XS)`
  margin: 0 6px;
  font-weight: 400; // HACK: Irregular font manipulation. We'll be adding copy.S.regular, so this is just by anticipation.

  ${plume.Link} {
    display: block;
    height: fit-content;
    line-height: 0;
  }
`

const SocialLinks = styled.ul<{ $lang: string }>`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: fit-content;
  justify-content: space-between;
  list-style: none;
  margin: 25px 0 0;
  padding: 0;
  width: 185px;

  ${plume.glyphs.Icon} {
    color: ${plume.COLORS.PRIMARY_BLACK};
    display: inline-block;
    fill-rule: evenodd;
    vertical-align: baseline;
  }

  ${plume.glyphs.thirdParty.Youtube} {
    position: relative;
    top: 2px;
  }

  @media screen and ${(props) => footerBreakpoint(props.$lang)} {
    margin: 0 auto;
  }
`

const LegalLinks = styled.ul<{ $lang: string }>`
  align-items: center;
  color: ${plume.COLORS.PRIMARY_BLACK_HOVER};
  font-weight: 400; // HACK: Irregular font manipulation
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  list-style: none;
  margin: 0;
  padding: 0;
  margin-top: 25px;

  @media screen and ${(props) => footerBreakpoint(props.$lang)} {
    margin: 0;
    justify-content: end;
  }
`
